import { combineReducers } from 'redux';
import adicionaIDEmpresa from './components/Home/reducers/reducersIDEmpresa';

export default combineReducers({
    dadosEmpresa: adicionaIDEmpresa
})

